export enum BlobContainerType {
  SurveyPhotos = 0,
  DocumentTemplates = 1,
  BuildingDocumentPhotos = 2,
  SNSDocuments = 3,
  BulkToProcess = 4,
  BulkProcessed = 5,
  BulkResults = 6,
}
